<template>
  <div class="companies-page pa-6">
    <p-container>
      <!-- Title -->
      <h2 class="mb-4">
        {{ $t('navigation.page.companies.title') }}
      </h2>
      <p-row>
        <!-- Search Field -->
        <p-col xs12 md6 lg3>
          <p-text-field v-model="page.companiesDataSource.filter.searchCriteria" clearable :label="$t('core.app.search')" context-icon="search"></p-text-field>
        </p-col>
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.organisationsDataSource.filter.selectedOrganisationId"
            clearable
            :label="$t('page.companies.select.organisationName')"
            :items="page.organisationNameItems"
            @input="page.refreshCompanies()"
          ></p-select>
        </p-col>
        <!-- Event Filter -->
        <p-col xs12 md6 lg3>
          <p-select
            v-model="page.eventsDataSource.filter.eventIdentifier"
            :label="$t('page.events.select.eventName')"
            :items="page.eventItems"
            @input="page.refreshCompanies()"
          ></p-select>
        </p-col>
      </p-row>
      <p-list-view
        ref="companyList"
        v-model="page.companiesList"
        :columns="page.companyColumns"
        :pagination.sync="page.companiesDataSource.paging"
        :loading="page.companiesDataSource.isLoading"
      >
        <template slot="table-actions">
          <!-- Refresh Button -->
          <p-button @click="page.refreshCompanies()">
            <p-icon>refresh</p-icon>
          </p-button>
        </template>
        <!-- Edit Company Button -->
        <template #actions="{ row }">
          <p-button @click="page.gotoDetail(row.values.id)">
            <p-icon>edit</p-icon>
          </p-button>
        </template>
      </p-list-view>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import CompaniesPage from './companies.vue.model';

  export default Vue.extend({
    role: ['Admin', 'Hostadmin'],
    auth: true,
    data: () => ({
      page: new CompaniesPage(),
    }),
    async beforeMount() {
      await this.page.initialize();
    },
  });
</script>
